import SectionHomeImg from './SectionHomeImg';
export default SectionHomeImg;
